import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import removeImageDark from "../../../../../../../../../assets/images/trash-icons/trash-02-dark.svg";
import removeImage from "../../../../../../../../../assets/images/trash-icons/trash-02.svg";
import { useTheme } from "../../../../../../../../../context/themeContext";
import { sendProjectApplicationAcceptedEmail } from "../../../../../../../../../helpers/emails";
import useManageProjects from "../../../../../../../../../hooks/useManageProjects";
import { setProjectApplicants } from "../../../../../../../../../store/slices/profile/manageProjectsSlice";
import DeleteConfirmation from "../delete-confirmation";
import styles from "./style.module.css";
import axios from "axios";
import { node_server } from "../../../../../../../../../constants";

const DefaultState = ({ setStatus, item, setTotalApplications }) => {
	const { theme, darkMode } = useTheme();
	const dispatch = useDispatch();
	const { projectApplicants } = useSelector((state) => state.manageProjects);
	const { handleDeleteApplicants } = useManageProjects();
	const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

	const handleAccept = async () => {
		setStatus("Accepted");
		const response = await axios.post(
			`${node_server}/api/projects/applications-status`,
			{
				projectId: item.project_id,
				userId: item.user_id,
				status: "Accepted",
			},
			{ withCredentials: true },
		);
		const error = response.status !== 200 ? response.data : null;
		if (error) {
			throw error;
		} else {
			await sendProjectApplicationAcceptedEmail(
				item.user_id,
				item.project_id,
			);
		}
	};

	const handleRemove = async (item) => {
		const updatedApplicants = projectApplicants.filter((app) => {
			return app.application_id !== item.application_id;
		});
		dispatch(setProjectApplicants(updatedApplicants));
		setTotalApplications(projectApplicants.length - 1);
		handleDeleteApplicants(item);
	};

	return (
		<Box className={styles.actions}>
			<DeleteConfirmation
				isOpen={isDeleteModalOpen}
				setIsOpen={setIsDeleteModalOpen}
				onDelete={handleRemove}
				project={item}
				text={"remove"}
			/>
			<Box
				className={styles.remove}
				onClick={() => setIsDeleteModalOpen(true)}
			>
				<img
					src={darkMode ? removeImageDark : removeImage}
					alt="remove"
				/>
				<Typography
					variant="body1"
					color={theme.palette.darkgrey.darkgrey400}
					sx={{
						fontSize: "12px",
						fontWeight: "700",
						letterSpacing: 2,
						textTransform: "uppercase",
					}}
				>
					Remove Application
				</Typography>
			</Box>
			<Button
				variant="contained"
				onClick={handleAccept}
				sx={{
					fontSize: "12px",
					fontWeight: "700",
					padding: "8px 20px",
					letterSpacing: 1,
				}}
			>
				Accept
			</Button>
		</Box>
	);
};

export default DefaultState;
